module.exports = __webpack_public_path__ + "img/Group3.af99c069.svg";